// UI Context - Genel UI state yönetimi (modals, theme, etc.)
import { createContext, useContext, useState, useCallback } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  // Modal States
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showCreditModal, setShowCreditModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showMemoryPanel, setShowMemoryPanel] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [showAssistantCreator, setShowAssistantCreator] = useState(false);
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [showAnalyticsPanel, setShowAnalyticsPanel] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  
  // Confirm Dialog
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: "",
    message: "",
    confirmText: "Onayla",
    cancelText: "İptal",
    variant: "default",
    onConfirm: () => {}
  });

  // Sidebar
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  
  // Theme (managed by localStorage, but we can track it here)
  const [theme, setTheme] = useState(() => localStorage.getItem("kaan-theme") || "dark");

  // Show confirm dialog
  const showConfirm = useCallback((config) => {
    setConfirmConfig(config);
    setShowConfirmDialog(true);
  }, []);

  // Close all modals
  const closeAllModals = useCallback(() => {
    setShowAuthModal(false);
    setShowProfileModal(false);
    setShowCreditModal(false);
    setShowTransferModal(false);
    setShowSubscriptionModal(false);
    setShowMemoryPanel(false);
    setShowAdminPanel(false);
    setShowAssistantCreator(false);
    setShowPaymentSuccess(false);
    setShowAnalyticsPanel(false);
    setShowConfirmDialog(false);
  }, []);

  // Toggle theme
  const toggleTheme = useCallback((newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("kaan-theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  }, []);

  const value = {
    // Auth Modal
    showAuthModal,
    setShowAuthModal,
    authMode,
    setAuthMode,
    
    // Profile Modal
    showProfileModal,
    setShowProfileModal,
    
    // Credit Modal
    showCreditModal,
    setShowCreditModal,
    
    // Transfer Modal
    showTransferModal,
    setShowTransferModal,
    
    // Subscription Modal
    showSubscriptionModal,
    setShowSubscriptionModal,
    
    // Memory Panel
    showMemoryPanel,
    setShowMemoryPanel,
    
    // Admin Panel
    showAdminPanel,
    setShowAdminPanel,
    
    // Assistant Creator
    showAssistantCreator,
    setShowAssistantCreator,
    
    // Payment Success
    showPaymentSuccess,
    setShowPaymentSuccess,
    
    // Analytics Panel
    showAnalyticsPanel,
    setShowAnalyticsPanel,

    // Upgrade Modal (Pro upsell)
    showUpgradeModal,
    setShowUpgradeModal,
    
    // Confirm Dialog
    showConfirmDialog,
    setShowConfirmDialog,
    confirmConfig,
    showConfirm,
    
    // Sidebar
    isSidebarOpen,
    setIsSidebarOpen,
    
    // Theme
    theme,
    toggleTheme,
    
    // Utilities
    closeAllModals
  };

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error("useUI must be used within a UIProvider");
  }
  return context;
}

export default UIContext;
